export class ConfigEntities {
  name: string;
  description: string;
  icon: string;
}

export class StorageProp{
  notificationPercentage: number;
  blobEnabled: string;
  blobContainer: string;
}

export class ConfigParameter {
  parameterName: string;
  parameterValue: string;
  parameterSection: string;
  parameterDisplayName?: string;
  parameterDescription?: string;
  parameterTypeBoolean?: string;
  parameterProfileInfo?: string;
  parameterRegex?: string;
  parameterDisabled: boolean;
  parameterSettingType: string;

  constructor(key: string, value: string, section: string, displayName: string, description?:string, type?: string, settingType?: string) {
    this.parameterName = key;
    this.parameterValue = value;
    this.parameterSection = section;
    this.parameterDisplayName = displayName;
    this.parameterDescription = description;
    this.parameterTypeBoolean = type;
    this.parameterSettingType = settingType;
  }
}

export class SyncHpcConfig {
  configParameters: ConfigParameter[];

  constructor(configParams) {
    this.configParameters = configParams;
  }
}

export class JSONItems {
  mode: string;
  otherHostIP?: string;
  otherHostUpTime?: string;
  status?: string;
  color?: string;
  isCurrentHostActive?: boolean;
}

export class GroupPolicyObjects {
  gpoName: string;
  userId: string;
  password: string;
}

export class GroupPolicyObjectsDTO {
  id: string;
  gpoName: string;
}

export class GpoWithRegistryKeyName {
  gpoNames: string[];
  registryKeys: GpoRegistry[];
}

export class UpdateGroupPolicyProp {
  username: string;
  password: string;
  gpoName: string;
  registryName: string;
  registryKey: string;
  registryValue: string;
}

export class GpoRegistry {
  humanReadableName: string;
  registryKey: string;
  registryName: string;
  description: string;
  value: string;
  isReverse: boolean;
}
